module.exports = __webpack_public_path__ + "img/zuijiashiqi@3x.7004c5ac.png";